import { z } from "zod";

export const ForgotPasswordSchema = z.object({
  email: z.string().nonempty({ message: "Email is required" }).email({
    message: "Must be a valid email",
  }),
});
